// src/hooks/useSsoCallback.js
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { exchangeCodeForToken, saveSession } from '../Services/authService';

/**
 * Login sayfasına dönen OAuth callback'i tek seferlik işler.
 * @param {object} opts
 * @param {(msg: string) => void} opts.onError
 * @param {(v: boolean) => void} opts.setLoading
 * @param {(key: string) => string} opts.t
 */
export const useSsoCallback = ({ onError, setLoading, t }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const handled  = useRef(false);   // Strict Mode çift çalışmayı engeller

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code   = params.get('code');
    const state  = params.get('state');
    const error  = params.get('error');

    // Callback yoksa çık
    if (!code && !error) return;

    // URL'yi hemen temizle — kullanıcı refresh'te tekrar denemesin
    window.history.replaceState({}, '', '/portal/login');

    if (error) {
      onError(t('api.default.service.response.error'));
      return;
    }

    // Daha önce işlendiyse çık (Strict Mode / double render)
    if (handled.current) return;
    handled.current = true;

    const run = async () => {
      setLoading(true);
      try {
        const data = await exchangeCodeForToken(code, state);

        if (data?.isSucceed) {
          saveSession(data.payload);
          navigate('/portal/changed-language', { replace: true });
        } else {
          onError(data?.messages?.[0]?.message || t('api.default.service.response.error'));
        }
      } catch (err) {
        console.error('[SSO] Token exchange hatası:', err);
        onError(t('api.default.service.response.error'));
      } finally {
        setLoading(false);
      }
    };

    run();
  }, []); 
};